<template>
  <b-container fluid class="mt-4 container-md">
    <b-row>
      <b-col cols="10">
        <b-input-group>
          <b-form-input
            type="email"
            placeholder="Enter e-mail"
            v-model="email"
          ></b-form-input>
          <b-form-select v-model="role" :options="roles"></b-form-select>
          <b-input-group-append>
            <b-button @click="onCreate" variant="outline-primary"
              >Create</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col cols="2"
        ><b-button @click="onListRefresh" variant="outline-primary"
          >List Users</b-button
        ></b-col
      >
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <b-table
          ref="users"
          :items="items"
          :fields="fields"
          select-mode="single"
          selectable
          hover
          stacked="sm"
          show-empty
          fixed
          bordered
          small
          @row-selected="onRowSelected"
        >
        </b-table>
        <b-button
          variant="danger"
          :disabled="this.delUser === null"
          @click="showModal"
          >Delete Selected
        </b-button>
        <b-modal
          scrollable
          id="modal-delete-confirm"
          centered
          @ok="onDelete"
          class="d-block text-center"
          title="Delete confirmation"
        >
          <p>
            Confirm you want to delete
            <b>{{ this.delUser }}</b>
          </p>
        </b-modal>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "Admin",
  data() {
    return {
      user: null,
      role: null,
      roles: [
        { value: null, text: "Please select an option" },
        { value: "admin", text: "Admin (manage users)" },
        { value: "internal", text: "Internal User (all columns visible)" },
        { value: "external", text: "External User (most limited)" },
      ],
      email: null,
      fields: ["email", "partner_id", "role"],
      items: [],
      delUser: null,
    };
  },
  methods: {
    showModal() {
      this.$nextTick(() => {
        this.$bvModal.show("modal-delete-confirm");
      });
    },
    validateEmail(email) {
      return email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    },
    async onCreate() {
      if (
        this.email !== null &&
        this.role !== null &&
        this.validateEmail(this.email)
      ) {
        try {
          let user = firebase.auth().currentUser;
          await user.getIdToken().then((token) => {
            fetch(
              process.env.VUE_APP_BASE_URL +
                "user/create?mail=" +
                this.email +
                "&role=" +
                this.role,
              {
                headers: {
                  Authorization: "JWT " + token,
                },
              }
            ).then((response) => {
              this.onListRefresh();
              this.email = null;
              this.role = null;
            });
          });
        } catch (error) {
          console.log(error);
        }
      }
    },
    async onListRefresh() {
      try {
        let user = firebase.auth().currentUser;
        await user.getIdToken().then((token) => {
          fetch(process.env.VUE_APP_BASE_URL + "user/list", {
            headers: {
              Authorization: "JWT " + token,
            },
          })
            .then((response) => response.json())
            .then((json_payload) => {
              this.items = json_payload;
            });
        });
      } catch (error) {
        console.log(error);
      }
    },
    async onDelete() {
      try {
        let user = firebase.auth().currentUser;
        await user.getIdToken().then((token) => {
          fetch(
            process.env.VUE_APP_BASE_URL + "user/delete?mail=" + this.delUser,
            {
              headers: {
                Authorization: "JWT " + token,
              },
            }
          ).then((response) => {
            this.$nextTick(() => {
              this.$bvModal.hide("modal-delete-confirm");
            });
            this.onListRefresh();
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    onRowSelected(items) {
      if (items && items[0]) {
        this.delUser = items[0].email;
      } else {
        this.delUser = null;
      }
    },
  },
  created() {
    this.onListRefresh();
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Admin.vue